import { TemperatureUnits } from "./generated/graphqlClient";
import { Temperature } from "./Temperature";
// static implements CustomUnitTypeStatics<number> (see below)
export class RelativeTemperature {
    constructor(valueInCelsius) {
        this.valueInCelsius = valueInCelsius;
    }
    //
    // Conversion and presentation capabilities as statics for optimized use
    //
    static fromPreferredUnits(valueInPreferredUnits, userPreferences) {
        if (userPreferences.temperatureUnits === TemperatureUnits.Fahrenheit) {
            return (valueInPreferredUnits * 5.0) / 9.0;
        }
        return valueInPreferredUnits;
    }
    static toPreferredUnits(valueInCelsius, userPreferences) {
        if (userPreferences.temperatureUnits === TemperatureUnits.Fahrenheit) {
            return (valueInCelsius * 9.0) / 5.0;
        }
        return valueInCelsius;
    }
    static toString(valueInCelsius, userPreferences) {
        return (RelativeTemperature.toPreferredUnits(valueInCelsius, userPreferences).toFixed(1) +
            RelativeTemperature.unitsToString(userPreferences));
    }
    static unitsToString(userPreferences) {
        // Prepend Delta to desired temperature units
        return "\u0394" + Temperature.unitsToString(userPreferences);
    }
    //
    // Conversion capabilities as members when boxing is required for type detection
    //
    toPreferredUnits(userPreferences) {
        return RelativeTemperature.toPreferredUnits(this.valueInCelsius, userPreferences);
    }
    toString(userPreferences) {
        return RelativeTemperature.toString(this.valueInCelsius, userPreferences);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error TS6133 /* declared but its value is never read */
const _customUnitTypeStaticsValidation = RelativeTemperature;
//# sourceMappingURL=RelativeTemperature.js.map